import type { FullPageModel } from '@sosocio/creator-types/app';

/**
 * Extracts previously used colors from pages and page objects.
 * @param limit - Maximum number of unique colors to return (default: 10)
 * @returns Array of unique, valid hex color strings
 */
export function extractPreviouslyUsedColors(
	fullPageModels: Pick<FullPageModel, 'model' | 'objects'>[],
	limit = 10,
): string[] {
	const colors: string[] = [];

	// Extract colors from all pages
	fullPageModels.forEach((fullPageModel) => {
		const {
			model: page,
			objects: pageObjects,
		} = fullPageModel;

		if (page.bgcolor) {
			colors.push(page.bgcolor);
		}

		// Extract colors from page objects
		pageObjects.forEach((pageObject) => {
			if (pageObject.bordercolor) {
				colors.push(pageObject.bordercolor);
			}

			if (pageObject.bgcolor) {
				colors.push(pageObject.bgcolor);
			}

			if (pageObject.fontcolor) {
				colors.push(pageObject.fontcolor);
			}
		});
	});

	// Remove duplicates and filter out transparent/invalid colors
	const uniqueColors = Array
		.from(new Set(colors))
		.filter((color) => (
			color
			&& color !== 'transparent'
			&& color !== 'none'
			&& color.startsWith('#')
		));

	// Limit to most recent unique colors
	return uniqueColors.slice(
		0,
		limit,
	);
}

export default extractPreviouslyUsedColors;
